import * as moment from 'moment';
import 'moment/locale/ru';
import React from 'react';
import PropTypes from 'prop-types';
import flags from '../../static-data/flags';
import config from '../../config';

function containRussianPlayers(pl) {
    let find = false;
    if (pl.length >= 3) {
        pl.forEach((item) => {
            if (item.country === 'Россия') find = true;
        });
    }
    return find;
}


function getCardClass(cardStatus, pubDate) {
    if (cardStatus === 'Не началось' || cardStatus === 'Идёт') {
        if (moment(pubDate * 1000).format('D') >= (new Date()).getDate()) {
            return 'event__card__blue';
        }
    }
    return 'event__card__gray';
}

function showLive(card) {
    if (card.status === 'Идёт') return true;

    if (card.flags.is_played !== 1 && (card.pub_date * 1000) < (new Date()).getTime() && parseInt(moment((card.pub_date * 1000)).format('D'), 10) === (new Date()).getDate()) {
        return true;
    }

    return false;
}

function isRussianMedals(card) {
    if (card.ch.flags.is_summary === 1
        && card.ch.flags.is_played
        && containRussianPlayers(card.ch.result.top)) {
        return true;
    }
    return false;
}

function getCardNameSplit(name, length = 50) {
    if (name.length > length) {
        return `${name.substr(0, length - 3)}...`;
    }
    const splitName = name.split('.');
    if (splitName.length > 3) return name;
    let resultName = splitName[0];
    splitName.forEach((item, index) => {
        if (index > 0) {
            if (index < splitName.length - 1) {
                resultName = `${resultName}.${item}`;
            } else {
                resultName = `${resultName}.<br />${item}`;
            }
        }
    });
    return resultName;
}


class EventCard extends React.Component {
    static propTypes = {
        data: PropTypes.instanceOf(Object).isRequired,
        full: PropTypes.instanceOf(Object).isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            data: this.props.data
        };
        this.countryName = Object.keys(flags);
        this.getCardName = this.getCardName.bind(this);
        this.toggleOpen = this.toggleOpen.bind(this);
    }


    getCardName(cardName) {
        let find = false;
        const findNames = [];
        this.countryName.forEach((item) => {
            if (cardName.indexOf(item) + 1 > 0) {
                find = true;
                findNames.push(item);
            }
        });

        if (find) {
            let newName = cardName;
            findNames.forEach((item) => {
                newName = newName.replace(item, '');
            });
            newName = newName.replace('.  - ', '');
            newName = newName.replace(':  - ', '');
            return getCardNameSplit(newName, 47);
        }
        return getCardNameSplit(cardName, 47);
    }

    getCountries(cardName, card = {}) {
        const findNames = [];
        let splitNames = cardName.indexOf(':') + 1 > 0 ? cardName.split(': ') : cardName.split('. ');
        if (cardName.indexOf('Квалификация') + 1 === 0 && splitNames.length > 0) {
            splitNames = splitNames[splitNames.length - 1].split(' - ');
            splitNames.forEach((item) => {
                if (this.countryName.indexOf(item) + 1 > 0) {
                    findNames.push(item);
                }
            });

            if (findNames[0] && findNames[1]) {
                const result = card.ch.result.full_res.split(':');

                return (
                    <React.Fragment>
                        <span className="card__country" title={findNames[0]}>
                            <span className="name">{findNames[0]}</span>
                            <span className="flag">
                                <img alt={findNames[0]} src={`${config.imagesUrl}/images/flags/${flags[findNames[0]]}`} />
                            </span>
                            {result[0] ? <span className="result">{result[0].replace('ОТ', '')}</span> : ''}
                        </span>
                        <span className="card__sep">:</span>
                        <span className="card__country card__second" title={findNames[1]}>
                            {result[1] ? <span className="result">{result[1].replace('ОТ', '')}</span> : ''}
                            <span className="flag">
                                <img alt={findNames[1]} src={`${config.imagesUrl}/images/flags/${flags[findNames[1]]}`} />
                            </span>
                            <span className="name">{findNames[1]}</span>
                        </span>
                    </React.Fragment>
                );
            }
        }
        // for top plays
        if (card.ch.flags.is_top && card.ch.flags.is_played && card.ch.flags.is_summary === 0) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_tops_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className="number">{index + 1}.</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                            </span>
                        ))}
                    </div>
                </React.Fragment>
            );
        }

        if (card.ch.flags.is_played && card.ch.flags.is_summary === 1) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            const medals = ['gold', 'silver', 'bronze'];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_medals_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className={`medal medal_${medals[index]}`} title={medals[index]}>{index + 1}</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                            </span>
                        ))}
                    </div>
                </React.Fragment>
            );
        }

        if (card.ch.flags.is_top && showLive(card)) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_tops_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className="number">{index + 1}.</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                            </span>
                        ))}
                    </div>
                </React.Fragment>
            );
        }

        return null;
    }

    getFullListInfo(card) {
        const findNames = [];
        const cardName = card.name;
        let splitNames = cardName.indexOf(':') + 1 > 0 ? cardName.split(': ') : cardName.split('. ');
        if (cardName.indexOf('Квалификация') + 1 === 0 && splitNames.length > 0) {
            splitNames = splitNames[splitNames.length - 1].split(' - ');
            splitNames.forEach((item) => {
                if (this.countryName.indexOf(item) + 1 > 0) {
                    findNames.push(item);
                }
            });
            if (findNames[0] && findNames[1]) {
                const result = card.ch.result.full_res.split(':');
                return (
                    <React.Fragment>
                        <div className="card--info--result">
                            <div className={`results--info ${result[0] && (result[0].indexOf('ОТ') + 1 > 0 || result[1].indexOf('ОТ') + 1 > 0) ? 'with__ot' : ''}`}>
                                <span className="card__country" title={findNames[0]}>
                                    <span className="name">{findNames[0]}</span>
                                    <span className="flag">
                                        <img alt={findNames[0]} src={`${config.imagesUrl}/images/flags/${flags[findNames[0]]}`} />
                                    </span>
                                    {result[0] ? <span className="result">{result[0].replace('ОТ', '')}</span> : ''}
                                </span>
                                <span className="card__sep">:{result[0] && (result[0].indexOf('ОТ') + 1 > 0 || result[1].indexOf('ОТ') + 1 > 0) ? <b>ОТ</b> : ''}</span>
                                <span className="card__country card__second" title={findNames[1]}>
                                    {result[1] ? <span className="result">{result[1].replace('ОТ', '')}</span> : ''}
                                    <span className="flag">
                                        <img alt={findNames[1]} src={`${config.imagesUrl}/images/flags/${flags[findNames[1]]}`} />
                                    </span>
                                    <span className="name">{findNames[1]}</span>
                                </span>
                            </div>
                            {card.ch.stadium && (<div className="area">
                                Арена: <b>{card.ch.stadium.name}</b>
                                ({card.ch.stadium.city},{card.ch.stadium.country_name})
                            </div>)}
                            {card.liveUpdate && <a href={card.liveUpdate} className="card--stream">Текстовая трансляция</a>}
                        </div>
                    </React.Fragment>
                );
            }
        }
        // for top plays
        if (card.ch.flags.is_top && card.ch.flags.is_played && card.ch.flags.is_summary === 0) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_tops_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className="number">{index + 1}.</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                                <span className="player_info">
                                    <span className="player_name">{item.player || item.country}</span>
                                    <span className="result">{item.result}</span>
                                </span>
                            </span>
                        ))}
                        {card.ch.stadium && (<div className="area">
                            Арена: <b>{card.ch.stadium.name}</b>
                            ({card.ch.stadium.city},{card.ch.stadium.country_name})
                        </div>)}
                        {card.liveUpdate && <a href={card.liveUpdate} className="card--stream">Текстовая трансляция</a>}
                    </div>
                </React.Fragment>
            );
        }

        if (card.ch.flags.is_played && card.ch.flags.is_summary === 1) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            const medals = ['gold', 'silver', 'bronze'];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_medals_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className={`medal medal_${medals[index]}`} title={medals[index]}>{index + 1}</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                                <span className="player_info">
                                    <span className="player_name">{item.player || item.country}</span>
                                    <span className="result">{item.result}</span>
                                </span>
                            </span>
                        ))}
                        {card.ch.stadium && (<div className="area">
                            Арена: <b>{card.ch.stadium.name}</b>
                            ({card.ch.stadium.city},{card.ch.stadium.country_name})
                        </div>)}
                        {card.liveUpdate && <a href={card.liveUpdate} className="card--stream">Текстовая трансляция</a>}
                    </div>
                </React.Fragment>
            );
        }

        if (card.ch.flags.is_top && showLive(card)) {
            // eslint-disable-next-line
            let Players = [...card.ch.result.top];
            return (
                <React.Fragment>
                    <div className="card--tops">
                        {Players.splice(0, 3).map((item, index) => (
                            <span className="tops--item" key={`card_tops_item_${card.last_modified}_${item.country}_${item.result}`}>
                                <span className="number">{index + 1}.</span>
                                <span className="flag" title={item.country}><img alt={item.country} src={`${config.imagesUrl}/images/flags/${flags[item.country]}`} /></span>
                                <span className="player_info">
                                    <span className="player_name">{item.player || item.country}</span>
                                    <span className="result">{item.result}</span>
                                </span>
                            </span>
                        ))}
                        {card.ch.stadium && (<div className="area">
                            Арена: <b>{card.ch.stadium.name}</b>
                            ({card.ch.stadium.city},{card.ch.stadium.country_name})
                        </div>)}
                        {card.liveUpdate && <a href={card.liveUpdate} className="card--stream">Текстовая трансляция</a>}
                    </div>
                </React.Fragment>
            );
        }

        return null;
    }

    toggleOpen() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const event = this.state.data;
        const cardCountries = this.getCountries(event.name, event);
        const cardPopup = this.getFullListInfo(event);

        return (
            <div data-tag={`OI-${event._id}`} className={`calendar__event_card ${getCardClass(event.status, event.pub_date)} ${event.name.indexOf('Россия') + 1 > 0 ? 'is_russia' : ''} ${isRussianMedals(event) ? 'fixed__russian_medals' : ''}`}>
                <div className="event_card__info">
                    <div className="card__info-date">
                        {moment(event.pub_date * 1000).format('D MMMM')}, {this.props.full[0].long.toLocaleLowerCase()}
                        {showLive(event) ? <span>Live</span> : ''}
                    </div>
                    <div className="card__info-time"><svg dangerouslySetInnerHTML={{ __html: '<use xlink:href="#clocks" ></use>' }} />{event.time}</div>
                    <div className="card__info-type" title={event.name} dangerouslySetInnerHTML={{ __html: this.getCardName(event.name) }} />
                    {cardCountries ? <div className="card__info-countries"><div className="cardInfoPopup">{cardPopup}</div></div> : null}
                </div>
            </div>
        );
    }
}

export default EventCard;



// WEBPACK FOOTER //
// ./src/components/Calendar/EventCardTable.jsx